import React from "react";
import * as C from "components/Desktop";
import * as M from "components/Mobile";
import { v4 as uuidV4 } from "uuid";

export const images = [
  { id: 1, component: <C.Slide1 key={uuidV4()} /> },
  { id: 2, component: <C.Slide2 key={uuidV4()} /> },
  { id: 3, component: <C.Slide3 key={uuidV4()} /> },
  { id: 4, component: <C.Slide4 key={uuidV4()} /> },
  { id: 5, component: <C.Slide5 key={uuidV4()} /> },
  { id: 6, component: <C.Slide6 key={uuidV4()} /> },
  { id: 7, component: <C.Slide7 key={uuidV4()} /> },
  { id: 8, component: <C.Slide8 key={uuidV4()} /> },
  { id: 9, component: <C.Slide9 key={uuidV4()} /> },
  { id: 10, component: <C.Slide10 key={uuidV4()} /> },
  { id: 11, component: <C.Slide11 key={uuidV4()} /> },
  { id: 12, component: <C.Slide12 key={uuidV4()} /> },
  { id: 13, component: <C.Slide13 key={uuidV4()} /> },
  { id: 14, component: <C.Slide14 key={uuidV4()} /> },
  { id: 15, component: <C.Slide15 key={uuidV4()} /> },
  { id: 16, component: <C.Slide16 key={uuidV4()} /> },
  { id: 17, component: <C.Slide17 key={uuidV4()} /> },
  { id: 18, component: <C.Slide18 key={uuidV4()} /> },
  { id: 19, component: <C.Slide19 key={uuidV4()} /> },
  { id: 20, component: <C.Slide20 key={uuidV4()} /> },
];

export const imagesMobile = [
  { id: 1, component: <M.Slide1 key={uuidV4()} /> },
  { id: 2, component: <M.Slide2 key={uuidV4()} /> },
  { id: 3, component: <M.Slide3 key={uuidV4()} /> },
  { id: 4, component: <M.Slide4 key={uuidV4()} /> },
  { id: 5, component: <M.Slide5 key={uuidV4()} /> },
  { id: 6, component: <M.Slide6 key={uuidV4()} /> },
  { id: 7, component: <M.Slide7 key={uuidV4()} /> },
  { id: 8, component: <M.Slide8 key={uuidV4()} /> },
  { id: 9, component: <M.Slide9 key={uuidV4()} /> },
  { id: 10, component: <M.Slide10 key={uuidV4()} /> },
  { id: 11, component: <M.Slide11 key={uuidV4()} /> },
  { id: 12, component: <M.Slide12 key={uuidV4()} /> },
  { id: 13, component: <M.Slide13 key={uuidV4()} /> },
  { id: 14, component: <M.Slide14 key={uuidV4()} /> },
  { id: 15, component: <M.Slide15 key={uuidV4()} /> },
  { id: 16, component: <M.Slide16 key={uuidV4()} /> },
  { id: 17, component: <M.Slide17 key={uuidV4()} /> },
  { id: 18, component: <M.Slide18 key={uuidV4()} /> },
  { id: 19, component: <M.Slide19 key={uuidV4()} /> },
  { id: 20, component: <M.Slide20 key={uuidV4()} /> },
  { id: 21, component: <M.Slide21 key={uuidV4()} /> },
  { id: 22, component: <M.Slide22 key={uuidV4()} /> },
  { id: 23, component: <M.Slide23 key={uuidV4()} /> },
  { id: 24, component: <M.Slide24 key={uuidV4()} /> },
  { id: 25, component: <M.Slide25 key={uuidV4()} /> },
  { id: 26, component: <M.Slide26 key={uuidV4()} /> },
];
